export default __webpack_public_path__ + "static/media/logoGreen1.34552e70.jpg";